<template>
    <div class="info-list">
        <Header/>
        <div class="blank20"/>
        <div style="margin:0 auto;width:1200px">
            <div class="title-header">
                <span class="weizhi">
                    <i class="fa fa-home">
                    </i> 当前位置：<a href="/">网站首页</a>
                    &gt; <a :href="`/sqjg`">全国授权机构</a> 
                </span>
            </div>
            <div class="news_list">
                <div v-for="(item, index) in list" :key="index" class="mode">
                    <div class="item"><a class="cover"> 
                        <img :src="item.image" :alt="item.name"> </a>
                    <div class="content">
                        <h2>{{item.name}}</h2>
                    </div>
                    </div>
                </div>
            </div>
            <el-pagination
                v-if="Number(total)!==0"
                :current-page="page"
                :page-sizes="[40, 60, 80, 100]"
                :page-size="limit"
                :total="Number(total)"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
export default {
    computed:{
    },
    data() {
        return {
            total:0,
            list:[],
            page:1,
            limit:40,
        }
    },
    async created() {
        this.getData();
    },
    methods: {
        handleSizeChange(size){
            this.limit = size;
            this.getData();
        },
        handleCurrentChange(page){
            this.page = page;
            this.getData();
        },
        async getData(){
            const params = {
                page:this.page,
                limit: this.limit,
            }
            const res = await this.$http.get('/api/index/getOrgList',params);
            if(res){
                this.list = res.list;
                this.total = res.total;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.weizhi a {
    font-size: 14px;
    line-height: 50px;
    padding: 0 5px;
    color: #606266;
}
a, a:link {
    cursor: pointer;
    color: #333;
    text-decoration: none;
}
a:hover{
    color: #224899;
}
.news_list{
    width:1200px;
}

.mode{width:280px; margin:0 10px 20px; border-radius:5px;display: inline-block;vertical-align: top;}
.mode .item{
    background-color:#f9f9f9;transition:all .2s ease-in-out; border-radius:5px;
    .content h2 {
        overflow: hidden;
        margin: 5px 12px;
        height: 30px;
        font-size: 16px;
        line-height: 30px;
        font-weight: 400;
        color: #666;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: color .3s ease;
    }
    .content{
        .meta-list {
            height: 30px;
            font-size: 0;
            line-height: 0;
            color: #999;
            padding: 0 10px;
        }
    }
}
.mode .item,li .item .cover img{-webkit-transition:all .2s ease-in-out;-moz-transition:all .2s ease-in-out;-ms-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out}
.mode .item:hover{-webkit-box-shadow:0 0 5px rgba(0,0,0,.9),0 0 10px rgba(0,0,0,.9);-moz-box-shadow:0 0 5px rgba(0,0,0,.9),0 0 10px rgba(0,0,0,.9);box-shadow:0 0 5px rgba(0,0,0,.5),0 0 10px rgba(0,0,0,.9)}
.mode .item .cover{width:280px;height:155px; padding-top:10px; overflow:hidden; display:inline-block; text-align:center;}
.mode .item .cover img{ max-width:280px;height:155px;transition:all .2s ease-in-out; border-radius:5px 5px 0 0;}

</style>
